import { Col, Form, Input, Modal, Row, Select } from 'antd'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import {
  DateTimeFormat,
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimplePrintCharge,
} from '../../../models/datetime'
import { getBusinessManagementDetailAsync } from './businessManagementSlice'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'

const { Option } = Select

export const DetailModal = (props: {
  editTenantId?: any
  fscrId?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const layout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
  }

  const getDetail = () => {
    dispatch(
      getBusinessManagementDetailAsync({
        fscrId: props?.fscrId,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        form.setFieldsValue({
          ...v,
          createTime: v?.createTime
            ? moment(v?.createTime)?.format(DateTimeFormatSimplePrintCharge)
            : '',
          firstTime: v?.firstTime
            ? moment(v?.firstTime)?.format(DateTimeFormatSimple)
            : '',
          licenceDeadline: v?.licenceDeadline
            ? moment(v?.licenceDeadline)?.format(DateTimeFormatSimple)
            : '',
          taxDeadline: v?.taxDeadline
            ? moment(v?.taxDeadline)?.format(DateTimeFormatSimple)
            : '',
          gspGmpDeadline: v?.gspGmpDeadline
            ? moment(v?.gspGmpDeadline)?.format(DateTimeFormatSimple)
            : '',
        })
      })
  }

  useEffect(() => {
    if (props.isModalVisible) {
      getDetail()
    } else {
      form.resetFields()
    }
  }, [props.isModalVisible])

  return (
    <Modal
      width={900}
      title='查看详情'
      visible={props.isModalVisible}
      footer={null}
      destroyOnClose
      onCancel={() => {
        props.onCancel()
      }}
      onOk={() => {
        props?.onOk()
      }}
    >
      <Form form={form}>
        <Row>
          <Col span={12}>
            <Form.Item {...layout} label='数据录入时间' name='createTime'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='首营日期' name='firstTime'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='首营企业名称' name='name'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='许可证编号' name='licenceNumber'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='许可证有效期' name='licenceDeadline'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='营业执照编号' name='supplierTaxNo'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='营业执照有效期' name='taxDeadline'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='许可证类型' name='licenceCategory'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='生产(经营)范围' name='supplierRange'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='开户户名' name='accountName'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='开户银行' name='bankName'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='银行账号' name='accountNo'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='GSP/GMP证书编号' name='gspGmpNumber'>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              {...layout}
              label='GSP/GMP证书有效期'
              name='gspGmpDeadline'
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item {...layout} label='业务员姓名' name='concatName'>
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
